<template>
  <div>
    <v-app-bar
      dense
      flat
      height="50"
    >
      <v-row align="center">
        <v-col
          xs="12"
          sm="5"
          md="4"
          class="d-none d-sm-flex"
        >
          <search-field
            :search-text="searchText"
            :status="status"
            @statusChange="changeStatus"
            @search="onSearch"
          />            
        </v-col>
        <v-col
          xs="12"
          sm="7"
          md="8"
          class="d-flex justify-end"
        >
          <v-btn
            color="primary"
            class="mr-3 elevation-0"
            @click="ExportPosCorporateList()"
          >
            <v-icon>mdi-cloud-download</v-icon>
          </v-btn>
          <v-btn
            id="menu_item_refresh"
            color="primary"
            :loading="loader"
            class="mr-2 elevation-0"
            @click.native="reload()"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <register
            :show-dialog.sync="register"
            @refresh="reload"
          />
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                id="account_add"
                slot="activator"
                :disabled="!$store.getters.checkUserPrivilege('CORPORATE')"
                class="elevation-0"
                color="success"
                @click="newCorporate()"
                v-on="on"
              >
                <v-icon>mdi-plus</v-icon> Corporate
              </v-btn>
            </template>
            <span>Register a new corporate.</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-app-bar>
    <v-card
      flat
      outlined
      tile
    >
      <v-card-text>
        <v-row>
          <v-col
            xs="12"
            class="d-flex d-sm-none"
          >
            <search-field
              :search-text="searchText"
              :status="status"
              @statusChange="changeStatus"
              @search="onSearch"
            />            
          </v-col>   
        </v-row>
        <!-- <v-row>
          <v-divider></v-divider>
        </v-row> -->
        <v-row>
          <v-col
            v-for="corporate in corporates"
            :key="corporate.id"
            cols="12"
            sm="4"
            md="3"
            xl="2"
            class="d-flex"
          >
            <v-card
              class="mx-auto"
              flat
              outlined
            >
              <v-card-text>
                <v-row justify="end">
                  <v-col cols="auto">
                    <corporate-options
                      :corporate-id="corporate.id"
                      :active="corporate.activeStatus"
                      :name="corporate.name"
                      @reload="getCorporates()"
                    />
                  </v-col>
                </v-row>
                <v-row
                  class="text-center"
                  no-gutters
                >
                  <v-col
                    cols="12"
                    class="text-h5"
                  >
                    {{ corporate.name }}
                  </v-col>
                  
                  <accounts
                    :corporate-id="corporate.id"
                    :count="corporate.accounts"
                  />

                  <v-col
                    cols="12"
                    class="subtitle-1"
                  >
                    Created @ {{ corporate.createdAt }}
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider class="mt-2 mx-4" />

              <v-card-actions>
                <v-row justify="center">
                  <v-col cols="auto">
                    <v-chip
                      v-if="corporate.activeStatus"
                      outlined
                      label
                      color="success--text"
                    >
                      Active
                    </v-chip>
                    <v-chip
                      v-else
                      outlined
                      label
                      color="error--text"
                    >
                      In-active
                    </v-chip>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-show="totalPage > 1">
        <v-row>
          <v-col>
            <v-pagination
              v-model="page"
              :length="totalPage"
              @input="getCorporates()"
            />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { failure, pagination } from "@/mixins/common";
import Register from "./Register";
import CorporateOptions from "./CorporateOptions";
import Accounts from "./Accounts";
import SearchField from "@/components/utils/SearchField";
import exportReport from "@/mixins/report";


export default {
	components: {
		Register,
		CorporateOptions,
    Accounts,
    SearchField
	},
	mixins: [failure, pagination,exportReport],
	data() {
		return {
			loader: false,
			corporates: [],
      sortKey: "name",
      searchKey: "name",
			searchText: null,
			register: false,
			page: 1,
			totalPage: 0,
      status: ""
		};
	},
	created() {
		this.init();
	},
	methods: {
		getCorporates() {
			this.loader = true;
			let url = `${this.ADMIN_API_URL}/corporates?page=${
				this.page - 1
			}&search_key=${this.searchKey}&sort_key=${this.sortKey}&limit=${this.limit}&status=${this.status}`;
			if (this.searchText) {
				url += `&search=${this.searchText}`;
			}
			this.$http.get(url).then(
				(res) => {
					this.corporates = res.body.data || [];
					this.totalPage = res.body.totalPage;
					this.page = res.body.pagination.page + 1;
					this.loader = false;
				},
				(failure) => {
					this.handleFailure(failure);
				}
			);
		},
		search() {
			this.page = 1;
			this.getCorporates();
		},
		reload() {
			this.searchText = null;
      this.status = "";
			this.search();
		},
    onSearch(val) {
      this.searchText = val;
      if (!val || val.length >= 3) {
        this.search();
      }
    },
		changeStatus(status) {
			this.status = status;
			this.search();
    },
		newCorporate() {
			this.register = true;
		},

		init() {
			this.$store.commit("setTitle", "Corporate");
			this.getCorporates();
		},
		clear() {
			this.errors = {};
			this.$refs.form.reset();
		},
    ExportPosCorporateList() {
      let url = `${this.ADMIN_API_URL}/export/corporates`;
      this.exportReport(url, ".csv", "Pos_corporates_list");
    }
	}
};
</script>
